const lan = {
  REDIRECT: "A redirecionar...",
  RULE: {
    SERVICE_TYPE: "Selecione o Tipo de Serviço",
    COUNTRY: "Por favor, selecione o seu país/região",
    USERNAME: "É necessário um nome de utilizador",
    EMAIL: "É necessário introduzir email",
    EMAIL2: "Por favor, insira um endereço de e-mail válido",
    PRODUCT: "Por favor, selecione o seu dispositivo",
    PRODUCTSN: "Por favor, insira o número de série do seu produto",
    PRODUCTSN_LEN: "Por favor, digite de 12 a 15 letras ou números",
    BIRTHDAY: "A data de aniversário é um campo obrigatório",
    REQUIRED: "Requerido",
  },
  SYS: {
    HEAD: "Sistema",
    NOSERVICE:
      "Desculpe, ASUS Chat para o seu país ou região selecionada não está disponível.",
    CHECK_FILESIZE:
      "Por favor, verifique o tamanho da imagem ou arquivo anexado. Limite:",
    RECONNECTED: "O estado da ligação voltou ao normal",
    UNABLE_SEND: "Não foi possível enviar o anexo",
    NO_NETWORK: "Sem ligação à Internet",
    NO_NETWORK_INFO:
      "Sem conexão com a Internet. Conecte-se à Internet e tente novamente.",
  },
  IDLE: {
    HEAD: "Esteve inativo por um tempo. Deseja continuar com o Chat?",
    BUTTON: "Continuar",
  },
  DISCONNECT: {
    HEAD: "O Chat foi terminado",
    BUTTON: "Terminar",
  },
  LAYOUT: {
    STEP_1: "Selecionar Produto",
    STEP_2: "Condições de Serviço",
    STEP_3: "Login",
    STEP_4: "Informação",
    SELECT_SKILL: "Selecionar Produto",
    PREV_STEP: "Anterior",
    NEXT_STEP: "Seguinte",
    NOTSET: "Não definido",
    AGREEN: "Concordo",
    NOTAGREEN: "Não concordo",
    LEAVE: "Sair",
    TYPE_HERE: "Escreva aqui",
    CHAT_DOWNLOAD:
      "Por favor clique aqui para guardar uma cópia do seu Chat com o Serviço de Apoio ao Cliente ASUS Online.",
  },
  COUNTRY: { SELECT_COUNTRY: "Selecione o país ou região do suporte" },
  POLICY: {
    PRIVACY: "Política de Proteção de Privacidade",
    SAT_SURVEY: "Termos de Serviço",
    CONFIRM_COUNTRY: {
      H1: "Estimado cliente ASUS,",
      P1:
        "Agora está a visitar o “Asus Online Customer Service” em Portugal que é diferente de sua região atual. De acordo com os Termos de Garantia ASUS, nem todos os produtos ASUS são aplicáveis ao serviço de Garantia e Suporte Internacional ASUS. Se o site regional acima que está a visitar não for a região onde comprou o produto ASUS, ou for diferente da sua região atual, isso pode afetar o seu direito. Pode continuar a usar o “ASUS Online Customer Service” em Portugal ou escolher “Asus Online Customer Service” para a sua região.",
      P2: "",
      P3: "",
      B1: "Mudar para ASUS",
      B2: "Website",
      B3: "Continuar a utilizar",
    },
    BULLETIN: {
      HEAD: "Notificação de uma mensagem importante",
      CONFIRM: "Eu entendi",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Por favor, preencha as informações de contato",
    SURVEY_TYPE: "Selecione o Tipo de Serviço",
    PROBLEM_BRIEF: "Como descreveria o seu problema?",
    TYPE1: "Pergunta geral",
    TYPE2: "Consulta de reparação",
    TYPE3: "Suporte técnico",
    TYPE4: "Consulta da garantia",
    TYPE5: "Opinião e Comentário",
    EC_TYPE1: "Informações de Produtos e Vendas",
    EC_TYPE2: "Evento Marketing",
    EC_TYPE3: "Estado do envio e da encomenda",
    EC_TYPE4: "Serviço de Devolução",
    SIGNUPDATA: "Suas informações de registro.",
    NAME: "Nome",
    TEL: "Número de telefone",
    ORDER_NO: "Order No.",
    BIRTHDAY: "Aniversário",
    LABEL_EMAIL: "Email",
    EMAIL: "E-Mail",
    DEVICEINFO: "Informações sobre o seu produto",
    DEVICENAME: "Nome do produto",
    MY_DEVICE: "Teu produto",
    MY_DEVICE_SELECT: "Seleciona o teu produto",
    MY_DEVICE_EMPTY: "Ainda não tens nenhum dispositivo.",
    LABEL_DEVICESN: "Serial Number",
    DEVICESN: "Número de série do produto",
    DEVICESN_ERROR: "O número de série inserido é inválido.",
    PREPARE: "Criando a sala de chat, prepara-se para conversar",
    START: "Iniciar o chat",
    AGE_LIMIT: "Limite de idade",
    AGE_LIMIT_DESC:
      "Não cumpre os requisitos de idade para utilizar o ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Sala de chat existente detectada",
      P1:
        "Tem certeza de que deseja iniciar uma conversa nova? Quando uma nova conversa é aberta, a conversa antiga será encerrada.",
      B0: "Confirmar",
      B1: "Cancelar",
    },
  },
  CONNECTTING: {
    P1: "Por favor aguarde um momento, e não feche a janela",
    P2: "O Sistema está a conectar a um Agente disponível",
    NOTE: "Sugestão",
    BEFORE_LEAVE: "Tem a certeza de que quer terminar este ASUS Chat?",
    B0: "Terminar",
    B1: "Espere e aguarde",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Contate a ASUS através de outros canais",
    MAIL: "Envie-nos um Email",
    TEL: "Contacte-nos",
    CLOSE: "Fechar",
  },
  WAITTING: {
    WATTING_NUM: "Posição na fila de espera",
    PEOPLE: "Cliente",
    NOTE: "Sugestão",
    BEFORE_LEAVEL: "Tem a certeza de que deseja sair da fila?",
    LEAVE_DESC: "Se já não desejar estar na fila, pode terminar o Chat",
    LEAVE: "Terminar o Chat",
    STAY: "Permaneça na fila",
  },
  CHATROOM: {
    TYPING: "O agente está a escrever",
    HEAD: {
      CLOSE_AMD_SURVEY: "Terminar o chat",
      TERMINATE: "Terminar o Chat",
    },
    FOOTER: { CHAT_FINISH: "O Chat foi terminado" },
    FINISH:
      "O chat terminou. Precisa de mais algum serviço ou suporte adicional?",
    SAT_SURVEY: {
      SAT: "Satisfeito",
      DISSAT: "Insatisfeito",
      SAT_CHOOSE: "Que tipo de Serviços? (Múltiplo)",
      HEAD: "Ficou satisfeito com o chat?",
      DESC:
        "Ouvir os seus comentários é uma força motriz para a nossa melhoria contínua. Se tiver alguma sugestão para o serviço ou suporte da ASUS, informe-nos.",
      OTHER_OPTION: "Outro",
      OTHER_REASON: "Por favor, preencha o outro motivo",
      SEND: "Enviar",
    },
    CLOSE: {
      TITLE: "Tem certeza de que deseja encerrar o ASUS Chat?",
      P1:
        'Clique em "Terminar" para fechar a janela. Se precisar de usar o chat novamente, é necessário efetuar um novo pedido de chat".',
      B0: "Terminar",
      B1: "Cancelar",
    },
  },
  ERROR: {
    H1: "A sala de chat não existe ou o chat já terminou",
    CLOSE: "Feche a janela",
  },
  CHAT_END: {
    H1: "Muito obrigado, o Chat já terminou",
    CLOSE: "Feche a janela",
  },
  CHAT_CLOSE: {
    H1:
      "A sua rede está em baixo há mais de 300 segundos, pelo que terminámos esta conversa.",
    DESC:
      "Se utilizar uma rede sem fios ou uma rede móvel, por favor tente encontrar um local com melhor sinal; ou mude para uma ligação de rede com fios, pedimos desculpa pelo inconveniente",
    CLOSE: "Feche a janela",
  },
  SURVEY_DONE: {
    H1: "Obrigado. Já completou o inquérito de satisfação do serviço",
    P1:
      'O seu feedback é uma força motriz para a nossa melhoria contínua. Obrigado por ter tido tempo para completar o Inquérito de Satisfação do Serviço. Se necessitar de Serviço ou Suporte adicional, por favor clique em "Iniciar novo Chat". Por favor clique em "Fechar a janela" para terminar o Chat, se tivermos resolvido a sua dúvida.',
    AGAIN: "Iniciar novo Chat",
    CLOSE: "Feche a janela",
    YT_H1:
      "Encontre dicas, sugestões e conhecimentos técnicos com os vídeos de apoio da ASUS.",
    YT_H2: "Clique para explorar!",
  },
  AGENT_OFFLINE: {
    H1:
      "A ligação à Internet do agente não responde; o seu Chat está actualmente interrompido",
    H2:
      "Por favor, não feche a janela; estamos a trabalhar arduamente para retomar o Chat",
    DESC:
      "Também pode escolher terminar a sessão para realizar um inquérito, ou clicar em 'Iniciar novo Chat', e designaremos imediatamente um novo agente para continuar a sessão. Desculpe por qualquer inconveniente causado",
    AGAIN: "Iniciar novo Chat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Impossibilidade de utilizar a câmara e o microfone",
    H1: "Pronto para se juntar?",
    P1:
      "Para que o pessoal do serviço de apoio ao cliente da ASUS possa ajudá-lo a resolver o problema de forma mais eficiente, deve permitir que o dispositivo aceda à sua câmara e microfone para entrar na sala de conversação por vídeo e certifique-se de que a sua ligação à rede móvel está estável e a funcionar normalmente",
    P2:
      "Depois de aceder, pode ainda definir livremente o botão da lente e o silenciador do microfone.",
    VIDEO_STATE: "Estado do vídeo",
    VIDEO_ON: "On",
    VIDEO_OFF: "Off",
    AUDIO_STATE: "Estado do áudio",
    AUDIO_ON: "On",
    AUDIO_OFF: "Off",
    ENTER: "Juntar-se",
    HANGUP: {
      H1: "Suspensão",
      P1: "Tem a certeza de que vai desligar a conversação por vídeo?",
      CONFIRM: "Confirmar",
      CANCEL: "Cancelar",
    },
    END: {
      H1: "A videochamada terminou",
      P1:
        "Obrigado, esta conversa por vídeo terminou, pode fechar esta janela.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Selecionar Produto",
      STEP_2: "Condições de Serviço",
      STEP_3: "Login",
      STEP_4: "Informação",
      SELECT_SKILL: "Selecionar Produto",
      WELCOME: "Bem-vindo",
      AGREE: "Concordo",
      START: "Iniciar",
      CANCEL: "Cancelar",
      WAIT: "Por favor, aguarde",
      INPUT: "Introduzir texto",
      TRANSFER_TOAGENT: "Transferir para o agente.",
      READMORE:
        "Pode também consultar as seguintes FAQ relacionadas, obrigado.",
      COLLAPSE: "Ocultar",
      INPUT_SN: "Por favor, digite novamente o número de série",
      YOU_MAY_ALSO: "Você também pode querer perguntar:",
      FOR_FURTHER: "Para mais informações, por favor consulte:",
    RECORDING: "Por favor, comece a falar...",
      RECORDING_NOT_SUPPORTED:
        "O seu navegador não suporta reconhecimento de voz",
      RECORDING_NOT_FOUND:
        "NNenhum dispositivo de gravação detectado. Por favor, verifique o seu microfone e permissões.",
},
    IS_COMPONENT_SN: "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "Tipo de produto",
      MODEL: "Nome do produto",
      SERIALNO: "Número de série do produto",
      STATUS: "Estado da garantia",
      DATE: "Data de expiração da garantia",
    },
    HEAD: {
      LEAVE: "Sair",
      CREATE_NEW: "Criar nova sala",
    },
    ENTRANCE: {
      POLICY: "Política de privacidade",
      AGREE: "Clique em Aceitar para iniciar a conversa",
    },
    MESSAGE: {
      WAIT: "Aguarde, estamos à procura de uma solução.",
    },
    END: "Conversação Terminada",
    END_MSG: "Temos todo o gosto em servi-lo. A conversa terminou.",
    END_SURVEY: "Inquérito de satisfação",
    END_SURVEY_MSG: "Temos todo o gosto em servi-lo. A conversa terminou.",
    BACKHOME: "Regressar à página inicial",
    SURVEY: {
      DESC: "Avalie a sua experiência com o assistente virtual da ASUS.",
      SAT: "Satisfeito",
      DISSAT: "Insatisfeito",
      FEEDBACK: "Por favor, preencha os seus comentários.",
      SEND: "Enviar",
      BACK: "Cancelar",
    },
    SURVEY_DISLIKE: {
      H1: "Porque é que não está satisfeito com a resposta?",
      P:
        "Os seus comentários ajudam-nos a melhorar a qualidade do nosso serviço.",
      BUTTON: "Enviar",
    },
    HISTORY: {
      TITLE: "Histórico",
      AGO: "Há {hours} horas",
      CONTINUE: "Continuar Chat",
      CLOSE: "O Chat foi encerrado.",
      RESTART: "Reiniciar com o Assistente Virtual",
      NON_SERVICE: "Horário Fora de Serviço",
      VIEW_HISTORY: "Clique para ver o histórico mais recente do chat.",
    },
  },
};
export default lan;
